import {
  CloseButton,
  FormTitle,
  FunctionButtonContainer,
  HorizontalContainer,
  InfoArea,
  ScreenRoot,
  SmallTitleText,
  StyledPaper,
  StyledTable,
} from "../styles";
import { useHistory, useLocation } from "react-router";
import { BackButton, BackButtonContainer } from "./styles";
import { ActionButton } from "../parser/styles";
import React, { useEffect, useState } from "react";
import { FunctionalButton } from "../../../../components/functionalButton";
import Select from "../../../../components/selectField";
import { Dialog } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PledgxLogo from "assets/common/pledgxLogo";
import Input from "../../../../components/inputField"; // import { dummyBalanceSheetSplit } from "../parser/dummy";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../components/filesListTable/styles";
import { saveTransferData } from "../../../../api/external_data";
import { AlertPopup } from "../../../../components/alertPopup/alertPopup";
import Success from "../../../../assets/dashboardIcons/Success";
import DeleteIcon from "../../../../assets/buyers/deleteIcon";

const financialDocumentPropertyOrdering = {
  balanceSheet: [
    "company-name",
    "reporting-dates",
    "reporting-year",
    "cash",
    "marketable-securities",
    "accounts-receivable-progress",
    "accounts-receivable-retention",
    "deferred-assets",
    "inventory",
    "prepaid-expenses-current",
    "other-current-assets",
    "total-current-assets",
    "prepaid-expenses-non-current",
    "plant-and-equipment",
    "machinery-and-vehicles",
    "furniture-and-fixture",
    "real-estate",
    "other-fixed-assets",
    "accumulated-depreciation",
    "other-non-current-assets",
    "assets-on-lease",
    "cash-restricted",
    "shareholder-loans",
    "intangible-assets",
    "total-assets",
    "long-term-loan-payable",
    "bills-payable",
    "accounts-payable-progress",
    "accounts-payable-retention",
    "other-payables",
    "deferred-revenue",
    "current-portion-long-term-debt",
    "current-lease-liability",
    "loan-payable",
    "employee-loans",
    "current-taxes",
    "deferred-taxes",
    "loans-from-shareholders",
    "accrued-expenses",
    "total-current-liabilities",
    "long-term-lease-liability",
    "long-term-debt-other",
    "long-term-deferred-tax",
    "other-liabilities",
    "minority-interest",
    "total-liabilities",
    "subordinated-debt",
    "share-capital",
    "retained-earnings",
    "net-worth",
    "total-liability-net-worth",
    "currency",
  ],
  profitAndLoss: [
    "company-name",
    "reporting-dates",
    "reporting-year",
    "gross-contract-income",
    "management-fee-income",
    "other-operating-income",
    "intercompany-revenue",
    "total-operating-revenue",
    "wage-expense",
    "subcontract-expense",
    "material-expense",
    "equipment-expense",
    "other-direct-expenses",
    "exploration-and-evaluation-expense",
    "intercompany-direct-expense",
    "total-direct-expense",
    "gross-profit",
    "admin-expense",
    "other-non-operating-expense",
    "salary-and-bonus",
    "depreciation",
    "intercompany-overhead-expense",
    "total-overhead-expense",
    "operating-profit",
    "other-income",
    "discretionary-bonus",
    "interest-expense",
    "income-tax-current",
    "income-tax-deferred",
    "net-income-after-tax",
  ],
  cashflow: [
    "company-name",
    "reporting-dates",
    "reporting-year",
    "net-income",
    "depreciation-cf",
    "bad-debt-expense",
    "income-tax-deferred-cf",
    "change-in-assets",
    "change-in-liabilities",
    "net-cash-operating",
    "net-cash-investing",
    "loan-proceeds",
    "loan-repayment",
    "dividends",
    "net-cash-financing",
    "net-cash-flow",
  ],
};

const modelMappings = {
  profitAndLoss: "Profit and Loss",
  cashflow: "Cashflow",
  balanceSheet: "Balance Sheet",
  workInProgress: "Work In Progress",
  workCompleted: "Work Completed",
};

export default function DocumentViewer() {
  const location = useLocation();
  const history = useHistory();

  const [showEditFieldPopup, setShowEditFieldPopup] = useState(false);

  const [editingFieldData, setEditingFieldData] = useState(null);
  const [expandedProjects, setExpandedProjects] = useState([]);
  const [expandedYear, setExpandedYear] = useState([]);

  const [pdfSrc, setPdfSrc] = useState();

  const {
    splitFile,
    pdfBlob,
    selectedAccount,
    clientDocumentsId,
    splitFilesCount,
    index,
    documents,
    documentFiles,
    documentId,
    file,
  } = location.state || {};

  const [isSaving, setIsSaving] = useState(false);

  // for local dev
  // const splitFile = dummyBalanceSheetSplit;

  const [newData, setNewData] = useState(splitFile);
  //console.log("split file in document viewer ", newData);

  const [selectedAccountData, setSelectedAccountData] =
    useState(selectedAccount);
  const [clientDocumentsIdData, setClientDocumentsIdData] =
    useState(clientDocumentsId);
  const [splitFileCountData, setSplitFileCountData] = useState(splitFilesCount);
  const [showSaveFieldChangesFailedPopup, setShowSaveFieldChangesFailedPopup] =
    useState(false);
  const [
    showSaveFieldChangesSuccessPopup,
    setShowSaveFieldChangesSuccessPopup,
  ] = useState(false);

  const getProjectName = (projectEntity) => {
    const nameProperty = projectEntity.properties.find(
      (prop) => prop.type === "project_name",
    );
    return nameProperty ? nameProperty.mentionText : "Unnamed Project";
  };

  const getYear = (yearEntity) => {
    const nameProperty = yearEntity.properties.find(
      (prop) => prop.type === "reporting-year",
    );
    return nameProperty ? nameProperty.mentionText : "Unnamed Year";
  };
  const getReportingYears = () => {
    const yearEntities = newData.labellerOutput.entities.filter(
      (entity) => entity.type === "year",
    );

    const reportingYears = yearEntities
      .map((entity) => {
        const reportingYearProperty = entity.properties.find(
          (prop) => prop.type === "reporting-year",
        );
        return reportingYearProperty ? reportingYearProperty.mentionText : null;
      })
      .filter((year) => year !== null);

    return reportingYears;
  };

  const updateSplitFile = (documents, index, newSplitFile) => {
    // Create a deep copy of the documents object
    const updatedDocuments = documents;

    // Check if documents array is not empty
    if (updatedDocuments.length > 0) {
      // Access the correct file and splitFile
      const file = updatedDocuments[index];
      //console.log("file ", file);
      // Check if file and splitFiles array exist
      if (
        file &&
        file.files[0].splitFiles &&
        Array.isArray(file.files[0].splitFiles)
      ) {
        if (file.files[0].splitFiles.length > 0) {
          //console.log("file.files[0].splitFiles", file.files[0].splitFiles);
          const splitFile = file.files[0].splitFiles[0]; // Accessing the first element directly
          //console.log("splitFile in document viewer updateSplitFile ", splitFile, newSplitFile);
          // Update the splitFile with the new data if it exists
          if (splitFile) {
            Object.assign(splitFile, newSplitFile);
            console.log("split file & newSplitFile ", splitFile, newSplitFile);
          } else {
            console.error("Split file is undefined or null");
          }
        } else {
          //console.log("file.files[0].splitFiles", file.files[0].splitFiles);
          console.error("splitFiles array is empty or undefined");
        }
      } else {
        console.error("File or splitFiles array is undefined or not an array");
      }
    } else {
      console.error("Documents array is empty");
    }

    return updatedDocuments;
  };
  // Utility function to get missing types for a given project name
  const getMissingTypes = (projectName) => {
    // Define the list of required types
    const requiredTypes = [
      "billings_to_date",
      "contract_number",
      "cost_incurred_to_date",
      "current_year_contract_costs",
      "current_year_earned_revenue",
      "estimated_cost_of_revenue",
      "estimated-gross-profit",
      "project_name",
      "project_value_or_estimated_revenue",
    ];

    // Find the project entity by projectName
    const projectEntity = newData.labellerOutput.entities.find((entity) => {
      const nameProperty = entity.properties.find(
        (prop) => prop.type === "project_name",
      );
      return nameProperty && nameProperty.mentionText === projectName;
    });

    // If the project is not found, return all required types as missing
    if (!projectEntity) {
      console.warn(`Project "${projectName}" not found.`);
      return requiredTypes;
    }

    // Extract existing types from the project's properties
    const existingTypes = projectEntity.properties.map((prop) => prop.type);

    // Determine which required types are missing
    const missingTypes = requiredTypes.filter(
      (type) => !existingTypes.includes(type),
    );

    return missingTypes;
  };

  const getFinancialLabels = () => {
    const entities = newData.labellerOutput.entities;

    // Set to store unique types
    const uniqueTypes = new Set();

    entities.forEach((entity) => {
      // Add entity type if it exists
      if (entity.type) {
        uniqueTypes.add(entity.type);
      }

      // Add property types if they exist
      if (entity.properties && Array.isArray(entity.properties)) {
        entity.properties.forEach((prop) => {
          if (prop.type) {
            uniqueTypes.add(prop.type);
          }
        });
      }
    });

    // Convert Set to Array for easier handling
    const allUniqueTypes = Array.from(uniqueTypes);
    return allUniqueTypes;
  };

  const toggleProjectExpansion = (projectId) => {
    setExpandedProjects((prevExpanded) =>
      prevExpanded.includes(projectId)
        ? prevExpanded.filter((id) => id !== projectId)
        : [...prevExpanded, projectId],
    );
  };

  const toggleYearExpansion = (yearId) => {
    setExpandedYear((prevExpanded) =>
      prevExpanded.includes(yearId)
        ? prevExpanded.filter((id) => id !== yearId)
        : [...prevExpanded, yearId],
    );
  };

  const updateSplitWithNewOrEditedFieldData = () => {
    newData.edited = true;
    if (editingFieldData.mode === "new") {
      console.log("saving changes for new field", editingFieldData);
      if (isFinancialDocument(newData.labellerModel)) {
        const year = editingFieldData.entity.year;
        const yearEntityIndex = newData.labellerOutput.entities.findIndex(
          (entity) => {
            if (entity.type !== "year") return false;

            const reportingYearProperty = entity.properties.find(
              (prop) => prop.type === "reporting-year",
            );

            return (
              reportingYearProperty &&
              reportingYearProperty.mentionText === year
            );
          },
        );

        console.log("yearEntity ", yearEntityIndex);

        newData.labellerOutput.entities[yearEntityIndex].properties.push(
          editingFieldData.entity,
        );

        console.log(
          "after push: ",
          newData.labellerOutput.entities[yearEntityIndex].properties.filter(
            (property) => property.id === undefined,
          ),
        );
        //
        setNewData(newData);
        setIsSaving(true);
        handleClose();
      } else if (isWipOrWorkCompletedDocument(newData.labellerModel)) {
        // handle edge case where project_name is the new field being added (we can't use it to search)
        if (editingFieldData.entity.type === "project_name") {
          const projectIndex = newData.labellerOutput.entities.findIndex(
            (entity) => entity.id === editingFieldData.projectId,
          );
          console.log("project index: ", projectIndex);
        }
        const projectName = editingFieldData.projectName;
        setIsSaving(true);

        const ProjectIndex = newData.labellerOutput.entities.findIndex(
          (entity) =>
            entity.properties.some(
              (prop) =>
                prop.type === "project_name" &&
                prop.mentionText.toLowerCase() === projectName.toLowerCase(),
            ),
        );
        //console.log("ProjectIndex ", ProjectIndex);
        if (ProjectIndex === -1) {
          console.log(
            `couldn't find a match for a project with the project_name of "${projectName}"`,
          );
          return;
        }

        newData.labellerOutput.entities[ProjectIndex].properties.push(
          editingFieldData.entity,
        );

        setNewData(newData);
        handleClose();
        setIsSaving(true);
      } else {
        console.log("Unknown document type");
      }
      setNewestId((prevNewestId) => prevNewestId + 1);
    } else if (editingFieldData.mode === "edit") {
      console.log("editing field: ", editingFieldData);
      console.log("all entites", newData.labellerOutput.entities);
      // Updating non-project or year nested labels
      const id =
        editingFieldData.projectId ||
        editingFieldData.yearId ||
        editingFieldData.entity.id;

      // if the user is editing a property not under a year or a project
      if (!editingFieldData.propertyCopy) {
        const parentEntityIndex = newData.labellerOutput.entities.findIndex(
          (entity) => entity.id === id,
        );
        if (parentEntityIndex !== -1) {
          console.log("non-year or project edit");
          newData.labellerOutput.entities[parentEntityIndex].mentionText =
            editingFieldData.entity.mentionText;

          setNewData(newData);
          handleClose();
          setIsSaving(true);
        } else {
          console.log("Couldn't find parent entity with associated index");
        }
      }

      // if the user is editing a property under a year or a project
      if (editingFieldData.propertyCopy) {
        console.log("year or project property edit");
        let parentEntityIndex = -1;
        let propertyIndex = -1;

        newData.labellerOutput.entities.forEach((entity, entityIndex) => {
          if (
            (isFinancialDocument(newData.labellerModel) &&
              entity.type === "year") ||
            (!isFinancialDocument(newData.labellerModel) &&
              entity.type === "project")
          ) {
            const foundPropertyIndex = entity.properties.findIndex(
              (property) => property.id == editingFieldData.propertyCopy.id,
            );

            if (foundPropertyIndex !== -1) {
              parentEntityIndex = entityIndex;
              propertyIndex = foundPropertyIndex;
            }
          }
        });

        if (parentEntityIndex !== -1 && propertyIndex !== -1) {
          console.log(
            "properties: ",
            newData.labellerOutput.entities[parentEntityIndex].properties,
            " property index: ",
            propertyIndex,
          );

          newData.labellerOutput.entities[parentEntityIndex].properties[
            propertyIndex
          ].mentionText = editingFieldData.propertyCopy.mentionText;

          newData.labellerOutput.entities[parentEntityIndex].properties[
            propertyIndex
          ].type = editingFieldData.propertyCopy.type;
          //console.log("newData.labellerOutput.entities[parentEntityIndex]", newData);

          setNewData(newData);
          handleClose();
          setIsSaving(true);
        } else {
          console.log(
            "Couldn't find the property entity with associated index",
          );
        }
      }
    }
  };

  // handle missing project_name and reporting-years with default values
  useEffect(() => {
    let unnamedProjectCount = 0,
      unnamedYearCount = 0;

    newData.labellerOutput.entities.forEach((entity) => {
      if (entity.type == "project") {
        const projectNameIndex = entity.properties.findIndex(
          (property) => property.type == "project_name",
        );

        if (projectNameIndex == -1) {
          unnamedProjectCount++;
          entity.properties.push({
            type: "project_name",
            id: (newestId + 1).toString(),
            confidence: 0,
            mentionText: `Unnamed Project ${unnamedProjectCount}`,
          });
        }
      }
      if (entity.type == "year") {
        const reportingYearIndex = entity.properties.findIndex(
          (property) => property.type == "reporting-year",
        );

        if (reportingYearIndex == -1) {
          unnamedYearCount++;
          entity.properties.push({
            type: "reporting-year",
            id: (newestId + 1).toString(),
            confidence: 0,
            mentionText: `Unnamed Year ${unnamedProjectCount}`,
          });
        }
      }
    });
    setNewData(newData);
  }, []);

  useEffect(() => {
    const pdfUrl = URL.createObjectURL(
      new Blob([pdfBlob], { type: "application/pdf" }),
    );
    setPdfSrc(pdfUrl);

    return () => {
      URL.revokeObjectURL(pdfUrl);
    };
  }, []);

  const handleClose = () => {
    setShowEditFieldPopup(false);
  };

  useEffect(() => {
    //console.log("New data updated:",newData );
    if (isSaving) {
      handleClose();
      setIsSaving(false);
    }
  }, [newData]);

  const handleBackClick = () => {
    //console.log("data sent back to parser screen ");
    //   updatedFinancialData: newData,
    //   selectedAccount:selectedAccountData,
    //   clientDocumentsId:clientDocumentsIdData,
    //   splitFilesCount:splitFileCountData,
    // });
    //console.log("documents ", documents);
    //console.log("index ", index);
    //console.log("newData ", newData);
    const editedSplitDocuments = updateSplitFile(documents, index, newData);
    //console.log("editedDocuments ", editedSplitDocuments);
    //console.log("isSaving ", isSaving);

    console.log("edited Split Documents ", editedSplitDocuments);

    history.push({
      pathname: "/underwriter/idpdocuments/parser",
      search: "?ntld=true",
      state: {
        updatedFinancialData: newData,
        selectedAccount: selectedAccountData,
        clientDocumentsId: clientDocumentsIdData,
        splitFilesCount: splitFileCountData,
        editedDocuments: editedSplitDocuments,
        index: index,
        editedDocumentFiles: documentFiles,
      },
    });
  };

  const handleSaveChanges = async () => {
    const { bucketName, filePath, fileName, id } = file;

    console.log("newData ", newData);

    const updatedData = {
      id: documentId,
      files: {
        bucketName,
        filePath,
        fileName,
        id,
        splitFiles: newData,
      },
    };

    console.log("update data ", updatedData);

    const data = {
      update_transfer_data: updatedData,
      split_file_id: newData.id,
      document_ai_process_data_id: documentId,
      client_documents_id: clientDocumentsId,
      labeller_model: newData.labellerModel,
      account_id: selectedAccount.AccountId,
    };

    try {
      await saveTransferData(
        data,
        (response) => {
          console.log("saved ", response);
          setShowSaveFieldChangesSuccessPopup(true);
        },
        (error) => {
          console.log(`there was en error saving the data: ${error}`);
          setShowSaveFieldChangesFailedPopup(true);
        },
      );
    } catch (e) {
      console.log("error with saveTransferData");
    }
  };

  const isFinancialDocument = (labellerModel) => {
    return (
      labellerModel === "balanceSheet" ||
      labellerModel === "cashflow" ||
      labellerModel === "profitAndLoss"
    );
  };

  const isWipOrWorkCompletedDocument = (labellerModel) => {
    return (
      labellerModel === "workCompleted" || labellerModel === "workInProgress"
    );
  };

  const getNewestId = (data) => {
    let ids = [];
    data.labellerOutput.entities
      .filter(
        (entity) =>
          entity.type ===
          (isFinancialDocument(data.labellerModel) ? "year" : "project"),
      )
      .forEach(({ properties }) => {
        properties.forEach((property) => {
          ids.push(parseInt(property.id));
        });
      });

    console.log(ids);
    console.log("result ", Math.max(...ids));

    return Math.max(...ids);
  };

  const [newestId, setNewestId] = useState(getNewestId(newData));

  return (
    <ScreenRoot>
      <AlertPopup
        headerText="Failed to save your field changes"
        height="434px"
        subHeaderText="The was an error saving your field changes."
        openPopup={showSaveFieldChangesFailedPopup}
        setOpenPopup={setShowSaveFieldChangesFailedPopup}
        showIcon={true}
        width={"640px"}
        showButton={false}
      />
      <Dialog
        open={showSaveFieldChangesSuccessPopup}
        setOpen={setShowSaveFieldChangesSuccessPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            aria-label="close"
            onClick={() => {
              setShowSaveFieldChangesSuccessPopup(false);
            }}
          >
            <CloseIcon />
          </CloseButton>
          <Success />
          <FormTitle
            style={{
              marginTop: "10px",
              color: "#1A051D",
              fontSize: "22px",
              fontWeight: "600",
              fontStyle: "normal",
              lineHeight: "24px",
            }}
          >
            Saved
          </FormTitle>
          <SmallTitleText
            style={{
              marginBottom: 10,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            Your field changes have been saved
          </SmallTitleText>
          <InfoArea>
            <FunctionalButton
              buttonTitle="Close"
              handleButton={() => {
                setShowSaveFieldChangesSuccessPopup(false);
              }}
              width="308px"
              height="48px"
              isReversedColor={false}
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
            />
          </InfoArea>
        </StyledPaper>
      </Dialog>
      {editingFieldData && (
        <>
          <Dialog
            open={showEditFieldPopup}
            setOpen={setShowEditFieldPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
          >
            <StyledPaper elevation={0}>
              <CloseButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </CloseButton>
              <PledgxLogo />
              <FormTitle
                style={{
                  marginTop: "10px",
                  color: "#1A051D",
                  fontSize: "22px",
                  fontWeight: "600",
                  fontStyle: "normal",
                  lineHeight: "24px",
                }}
              >
                {editingFieldData.mode === "edit" ? "Edit" : "New"} Field
              </FormTitle>
              <SmallTitleText
                style={{
                  marginBottom: 10,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {modelMappings[newData.labellerModel]}
              </SmallTitleText>
              <InfoArea marginTop="0px">
                <div
                  style={{
                    margin: "0px",
                    marginBottom: "-15px",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {editingFieldData.mode === "new" &&
                    isWipOrWorkCompletedDocument(newData.labellerModel) && (
                      <>
                        <Select
                          label="Select the project this label belongs to"
                          options={newData.labellerOutput.entities
                            .filter((e) => e.type === "project")
                            .map((entity) => {
                              const projectNameProperty =
                                entity.properties.find(
                                  (prop) => prop.type === "project_name",
                                );
                              return {
                                value: projectNameProperty
                                  ? projectNameProperty.mentionText
                                  : "Unnamed Project",
                                label: projectNameProperty
                                  ? projectNameProperty.mentionText
                                  : "Unnamed Project",
                              };
                            })}
                          value={editingFieldData.projectName}
                          setValue={(val) => {
                            setEditingFieldData((prevState) => ({
                              ...prevState,
                              projectName: val,
                            }));
                          }}
                          validateFunc={(item) => Boolean(item)}
                          noCheckIcon={true}
                          showDropdownIndicator={true}
                        />
                      </>
                    )}
                  {editingFieldData.mode === "new" &&
                    isFinancialDocument(newData.labellerModel) && (
                      <>
                        <Select
                          label="Select the year this label belongs to"
                          options={getReportingYears().map((uniqueText) => ({
                            value: uniqueText,
                            label: uniqueText,
                          }))}
                          value={editingFieldData.entity.year}
                          setValue={(val) => {
                            setEditingFieldData((prevState) => ({
                              ...prevState,
                              entity: {
                                ...prevState.entity,
                                year: val,
                              },
                            }));
                          }}
                          validateFunc={(item) => Boolean(item)}
                          noCheckIcon={true}
                          showDropdownIndicator={true}
                        />
                      </>
                    )}
                  <Select
                    label="Select the type of this label"
                    options={
                      isWipOrWorkCompletedDocument(newData.labellerModel)
                        ? getMissingTypes(editingFieldData.projectName).map(
                            (uniqueType) => ({
                              value: uniqueType,
                              label: uniqueType,
                            }),
                          )
                        : financialDocumentPropertyOrdering[
                            splitFile.labellerModel
                          ].map((uniqueType) => ({
                            value: uniqueType,
                            label: uniqueType,
                          }))
                    }
                    value={
                      editingFieldData.entity || editingFieldData.propertyCopy
                        ? editingFieldData?.entity?.type ||
                          editingFieldData?.propertyCopy?.type
                        : editingFieldData.type
                    }
                    setValue={(val) => {
                      if (editingFieldData.entity) {
                        setEditingFieldData((prevState) => ({
                          ...prevState,
                          entity: {
                            ...prevState.entity,
                            type: val,
                          },
                        }));
                      } else {
                        setEditingFieldData((prevState) => ({
                          ...prevState,
                          propertyCopy: {
                            ...prevState.propertyCopy,
                            type: val,
                          },
                        }));
                      }
                    }}
                    validateFunc={(item) => Boolean(item)}
                    noCheckIcon={true}
                    showDropdownIndicator={true}
                  />

                  <Input
                    id="oneThirdInputWrap"
                    label={
                      editingFieldData.mode === "edit"
                        ? "Edit value"
                        : "Enter value"
                    }
                    type="text"
                    placeholder="0"
                    labelSize="12px"
                    fontSize="18px"
                    value={
                      editingFieldData?.entity?.mentionText ||
                      editingFieldData?.propertyCopy?.mentionText
                    }
                    setValue={(val) => {
                      if (editingFieldData.mode === "edit") {
                        //console.log("edit mode ", editingFieldData);
                        //console.log("val ", val);
                      }
                      if (editingFieldData.entity) {
                        setEditingFieldData((prevState) => ({
                          ...prevState,
                          entity: {
                            ...prevState.entity,
                            mentionText: val,
                          },
                        }));
                      }
                      if (editingFieldData.propertyCopy) {
                        setEditingFieldData((prevState) => ({
                          ...prevState,
                          propertyCopy: {
                            ...prevState.propertyCopy,
                            mentionText: val,
                          },
                        }));
                      }
                      //console.log("edit mode finish ", editingFieldData);
                    }}
                    noCheckIcon={true}
                    noErrorBorder={true}
                    style={{ width: "100%", paddingRight: "0px" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FunctionalButton
                      buttonTitle="Confirm"
                      handleButton={updateSplitWithNewOrEditedFieldData}
                      width="308px"
                      height="48px"
                      isReversedColor={false}
                      marginRight={"48px"}
                      marginLeft={"48px"}
                      marginTop={"30px"}
                      marginBottom={"20px"}
                      fontSize={"18px"}
                      disabled={false}
                      icon={null}
                      hasBoxShadow={true}
                      frontIcon={null}
                      weight={600}
                    />
                  </div>
                </div>
              </InfoArea>
            </StyledPaper>
          </Dialog>
        </>
      )}
      <HorizontalContainer>
        <div style={{ width: "50%", height: "90vh", overflowY: "auto" }}>
          <div style={{ display: "flex" }}>
            <BackButtonContainer>
              <BackButton onClick={handleBackClick}>
                {"< Back to Parser List"}
              </BackButton>
            </BackButtonContainer>
            <FunctionalButton
              buttonTitle="Save Changes"
              handleButton={() => handleSaveChanges()}
              width="200px"
              height="48px"
              isReversedColor={false}
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"14px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
            />
          </div>
          <StyledTable>
            <colgroup>
              <col style={{ width: "45%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              {/* <col style={{ width: "0%" }} /> */}
            </colgroup>
            <thead>
              <StyledTableRow header={true}>
                <StyledTableCell header={true}>Label</StyledTableCell>
                <StyledTableCell header={true}>Value</StyledTableCell>
                <StyledTableCell header={true}>Confidence</StyledTableCell>
                <StyledTableCell header={true}>Actions</StyledTableCell>
              </StyledTableRow>
            </thead>
            <tbody>
              {newData &&
                newData.labellerOutput.entities
                  .reduce((acc, entity) => {
                    if (entity.type === "year") {
                      const reportingYearProperty = entity.properties.find(
                        (prop) => prop.type === "reporting-year",
                      );

                      if (reportingYearProperty) {
                        const reportingYear = reportingYearProperty.mentionText;

                        const existingEntityIndex = acc.findIndex(
                          (e) =>
                            e.type === "year" &&
                            e.properties.some(
                              (prop) =>
                                prop.type === "reporting-year" &&
                                prop.mentionText === reportingYear,
                            ),
                        );

                        if (existingEntityIndex !== -1) {
                          // Create a new list of properties, avoiding duplicates
                          const existingProperties =
                            acc[existingEntityIndex].properties;
                          const newProperties = entity.properties.filter(
                            (newProp) =>
                              !existingProperties.some(
                                (existingProp) =>
                                  existingProp.type === newProp.type &&
                                  existingProp.mentionText ===
                                    newProp.mentionText,
                              ),
                          );

                          // Create a new entity object with merged properties
                          const updatedEntity = {
                            ...acc[existingEntityIndex],
                            properties: [
                              ...existingProperties,
                              ...newProperties,
                            ],
                          };

                          // Replace the existing entity with the updated entity
                          acc = [
                            ...acc.slice(0, existingEntityIndex),
                            updatedEntity,
                            ...acc.slice(existingEntityIndex + 1),
                          ];
                        } else {
                          acc.push(entity);
                        }
                      } else {
                        acc.push(entity);
                      }
                    } else {
                      acc.push(entity);
                    }
                    return acc;
                  }, [])
                  .reduce((acc, entity) => {
                    if (entity.type !== "project" && entity.type !== "year") {
                      const isDuplicate = acc.some(
                        (e) =>
                          e.type === entity.type &&
                          e.mentionText === entity.mentionText,
                      );

                      if (!isDuplicate) {
                        acc.push(entity);
                      }
                    } else {
                      acc.push(entity);
                    }
                    return acc;
                  }, [])
                  .sort((a, b) => {
                    const isAProject = a.type === "project";
                    const isBProject = b.type === "project";
                    const isAYear = a.type === "year";
                    const isBYear = b.type === "year";

                    if (isAProject && !isBProject) {
                      return 1;
                    }
                    if (!isAProject && isBProject) {
                      return -1;
                    }

                    if (
                      isAProject &&
                      isBProject &&
                      isWipOrWorkCompletedDocument(newData.labellerModel)
                    ) {
                      const aX =
                        a.pageAnchor?.pageRefs?.[0]?.boundingPoly
                          ?.normalizedVertices?.[0]?.x ?? Infinity;
                      const bX =
                        b.pageAnchor?.pageRefs?.[0]?.boundingPoly
                          ?.normalizedVertices?.[0]?.x ?? Infinity;

                      return aX - bX;
                    }

                    if (
                      isAYear &&
                      isBYear &&
                      isFinancialDocument(newData.labellerModel)
                    ) {
                      const getYear = (entity) => {
                        const reportingYearProperty = entity.properties.find(
                          (property) => property.type === "reporting-year",
                        );
                        return reportingYearProperty
                          ? parseInt(reportingYearProperty.mentionText, 10)
                          : -Infinity;
                      };

                      const aYear = getYear(a);
                      const bYear = getYear(b);

                      if (aYear !== bYear) {
                        return bYear - aYear;
                      }

                      const aIndex = financialDocumentPropertyOrdering[
                        newData.labellerModel
                      ].indexOf(a.type);
                      const bIndex = financialDocumentPropertyOrdering[
                        newData.labellerModel
                      ].indexOf(b.type);

                      if (aIndex === -1 && bIndex === -1) return 0;
                      if (aIndex === -1) return 1;
                      if (bIndex === -1) return -1;

                      return aIndex - bIndex;
                    }

                    return 0;
                  })
                  .map((entity, entityIndex) => {
                    if (entity.type === "project") {
                      return (
                        <React.Fragment key={entityIndex}>
                          <StyledTableRow
                            header={true}
                            onClick={() => toggleProjectExpansion(entity.id)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            <StyledTableCell colSpan="4">
                              <strong>{getProjectName(entity)}</strong>
                              <span
                                style={{
                                  float: "right",
                                  fontSize: "25px",
                                  fontWeight: "bold",
                                }}
                              >
                                {expandedProjects.includes(entity.id)
                                  ? "-"
                                  : "+"}
                              </span>
                            </StyledTableCell>
                          </StyledTableRow>
                          {expandedProjects.includes(entity.id) &&
                            entity.properties
                              .sort((a, b) => {
                                const aX =
                                  a.pageAnchor?.pageRefs?.[0]?.boundingPoly
                                    ?.normalizedVertices?.[0]?.x ?? Infinity;
                                const bX =
                                  b.pageAnchor?.pageRefs?.[0]?.boundingPoly
                                    ?.normalizedVertices?.[0]?.x ?? Infinity;

                                return aX - bX;
                              })
                              .map((property, propertyIndex) => (
                                <StyledTableRow
                                  header={true}
                                  key={propertyIndex}
                                >
                                  <StyledTableCell
                                    style={{ paddingLeft: "20px" }}
                                  >
                                    {property.type}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {property.mentionText}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {(property.confidence * 100).toFixed(2)}%
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <FunctionButtonContainer>
                                      <ActionButton
                                        onClick={() => {
                                          const propertyCopy = JSON.parse(
                                            JSON.stringify(property),
                                          );
                                          console.log(
                                            "propertyCopy ",
                                            propertyCopy,
                                          );
                                          setEditingFieldData({
                                            propertyCopy: propertyCopy,
                                            projectId: entity.id,
                                            mode: "edit",
                                          });
                                          setShowEditFieldPopup(true);
                                        }}
                                      >
                                        <EditIcon />
                                      </ActionButton>
                                      <ActionButton
                                        onClick={() => {
                                          const updatedProperties =
                                            newData.labellerOutput.entities[
                                              entityIndex
                                            ].properties.filter(
                                              (property, i) =>
                                                propertyIndex !== i,
                                            );

                                          setNewData({
                                            ...newData,
                                            labellerOutput: {
                                              ...newData.labellerOutput,
                                              entities:
                                                newData.labellerOutput.entities.map(
                                                  (entity, i) =>
                                                    i === entityIndex
                                                      ? {
                                                          ...entity,
                                                          properties:
                                                            updatedProperties,
                                                        }
                                                      : entity,
                                                ),
                                            },
                                          });
                                        }}
                                      >
                                        <DeleteIcon />
                                      </ActionButton>
                                    </FunctionButtonContainer>
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                        </React.Fragment>
                      );
                    } else if (entity.type === "year") {
                      return (
                        <React.Fragment key={entity.id}>
                          <StyledTableRow
                            onClick={() => toggleYearExpansion(entity.id)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            <StyledTableCell colSpan="4">
                              <strong>{getYear(entity)}</strong>
                              <span
                                style={{
                                  float: "right",
                                  fontSize: "25px",
                                  fontWeight: "bold",
                                }}
                              >
                                {expandedYear.includes(entity.id) ? "-" : "+"}
                              </span>
                            </StyledTableCell>
                          </StyledTableRow>
                          {expandedYear.includes(entity.id) &&
                            entity.properties
                              .sort((a, b) => {
                                const aIndex =
                                  financialDocumentPropertyOrdering[
                                    splitFile.labellerModel
                                  ].indexOf(a.type);
                                const bIndex =
                                  financialDocumentPropertyOrdering[
                                    splitFile.labellerModel
                                  ].indexOf(b.type);

                                if (aIndex === -1 && bIndex === -1) return 0;
                                if (aIndex === -1) return 1;
                                if (bIndex === -1) return -1;

                                return aIndex - bIndex;
                              })
                              .filter(
                                (property, index, self) =>
                                  index ===
                                  self.findIndex(
                                    (p) =>
                                      p.type === property.type &&
                                      p.mentionText === property.mentionText,
                                  ),
                              )
                              .map((property, propertyIndex) => (
                                <StyledTableRow key={property.id}>
                                  <StyledTableCell
                                    style={{ paddingLeft: "20px" }}
                                  >
                                    {property.type}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {property.mentionText}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {(property.confidence * 100).toFixed(2)}%
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <FunctionButtonContainer>
                                      <ActionButton
                                        onClick={() => {
                                          const propertyCopy = JSON.parse(
                                            JSON.stringify(property),
                                          );
                                          console.log(
                                            "propertyCopy ",
                                            propertyCopy,
                                          );
                                          setEditingFieldData({
                                            propertyCopy: propertyCopy,
                                            yearId: entity.id,
                                            mode: "edit",
                                          });
                                          setShowEditFieldPopup(true);
                                        }}
                                      >
                                        <EditIcon />
                                      </ActionButton>
                                      <ActionButton
                                        onClick={() => {
                                          const updatedProperties =
                                            newData.labellerOutput.entities[
                                              entityIndex
                                            ].properties.filter(
                                              (property, i) =>
                                                propertyIndex !== i,
                                            );

                                          setNewData({
                                            ...newData,
                                            labellerOutput: {
                                              ...newData.labellerOutput,
                                              entities:
                                                newData.labellerOutput.entities.map(
                                                  (entity, i) =>
                                                    i === entityIndex
                                                      ? {
                                                          ...entity,
                                                          properties:
                                                            updatedProperties,
                                                        }
                                                      : entity,
                                                ),
                                            },
                                          });
                                        }}
                                      >
                                        <DeleteIcon />
                                      </ActionButton>
                                    </FunctionButtonContainer>
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <StyledTableRow key={entity.id}>
                          <StyledTableCell>{entity.type}</StyledTableCell>
                          <StyledTableCell>
                            {entity.mentionText}
                          </StyledTableCell>
                          <StyledTableCell>
                            {(entity.confidence * 100).toFixed(2)}%
                          </StyledTableCell>
                          <StyledTableCell>
                            <FunctionButtonContainer>
                              <ActionButton
                                onClick={() => {
                                  const entityCopy = JSON.parse(
                                    JSON.stringify(entity),
                                  );
                                  setEditingFieldData({
                                    entity: entityCopy,
                                    mode: "edit",
                                  });
                                  setShowEditFieldPopup(true);
                                }}
                              >
                                <EditIcon />
                              </ActionButton>
                              <ActionButton
                                onClick={() => {
                                  const updatedData =
                                    newData.labellerOutput.entities.filter(
                                      (entity, i) => entityIndex !== i,
                                    );
                                  setNewData({
                                    ...newData,
                                    labellerOutput: {
                                      ...newData.labellerOutput,
                                      entities: updatedData,
                                    },
                                  });
                                }}
                              >
                                <DeleteIcon />
                              </ActionButton>
                            </FunctionButtonContainer>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    }
                  })}
            </tbody>
          </StyledTable>
          <button
            onClick={() => {
              if (isFinancialDocument(newData.labellerModel)) {
                setEditingFieldData({
                  splitId: splitFile.id,
                  entity: {
                    year: newData.labellerOutput.entities
                      .find((entity) => entity.type === "year")
                      .properties.find((prop) => prop.type === "reporting-year")
                      .mentionText,
                    labellerModel: newData.labellerModel,
                    type: "",
                    mentionText: "",
                    confidence: 1,
                    id: "" + (newestId + 1),
                  },
                  mode: "new",
                });
              }

              if (isWipOrWorkCompletedDocument(newData.labellerModel)) {
                setEditingFieldData({
                  splitId: splitFile.id,
                  entity: {
                    project: "",
                    labellerModel: newData.labellerModel,
                    type: "",
                    mentionText: "",
                    confidence: 1,
                    id: (newestId + 1).toString(),
                  },
                  mode: "new",
                });
              }
              setShowEditFieldPopup(true);
            }}
            style={{
              position: "sticky",
              bottom: "10px",
              left: "10px",
              zIndex: 1000,
              backgroundColor: "white",
              color: "#ff6d1d",
              padding: "10px 20px",
              borderRadius: "5px",
              border: "1px solid #ff6d1d",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            New Field
          </button>
        </div>
        <div style={{ width: "50%" }}>
          <iframe src={pdfSrc} title="PDF Viewer" width="100%" height="100%" />
        </div>
      </HorizontalContainer>
    </ScreenRoot>
  );
}

const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1744_575)">
      <path
        d="M15.4864 0.500019C16.1662 0.502058 16.8176 0.772743 17.2983 1.25297L18.6853 2.63071C18.9426 2.87469 19.1476 3.16847 19.2877 3.49416C19.4278 3.81984 19.5 4.17062 19.5 4.5251C19.5 4.87958 19.4278 5.23035 19.2877 5.55604C19.1476 5.88173 18.9426 6.17551 18.6853 6.41949L11.4699 13.6286C10.3235 14.7981 9.17701 15.9355 8.02255 17.0729C7.90697 17.1876 7.76731 17.2752 7.61368 17.3293C5.52924 18.0341 3.43679 18.723 1.35235 19.4199C1.23457 19.4664 1.11002 19.4934 0.983563 19.5C0.902828 19.4953 0.824337 19.4717 0.754491 19.431C0.684644 19.3903 0.625421 19.3336 0.581651 19.2657C0.537882 19.1977 0.510805 19.1204 0.502629 19.04C0.494453 18.9596 0.50541 18.8785 0.534607 18.8031L1.85742 14.7981C2.13 13.9971 2.39457 13.196 2.65913 12.395C2.70283 12.2623 2.77695 12.1416 2.87559 12.0426L13.5784 1.30904C13.825 1.05206 14.1213 0.84784 14.4493 0.708768C14.7773 0.569695 15.1301 0.498675 15.4864 0.500019ZM13.0813 3.3356L3.98996 12.395L7.5736 15.9996L16.665 6.93214L13.0813 3.3356ZM17.4747 6.17118C17.6591 5.98694 17.8595 5.81072 18.0359 5.61848C18.3076 5.33019 18.4589 4.94913 18.4589 4.55313C18.4589 4.15714 18.3076 3.77608 18.0359 3.48779C17.5388 2.95111 17.0177 2.44648 16.4966 1.94985C16.3272 1.7908 16.1232 1.67327 15.9006 1.60655C15.678 1.53982 15.4429 1.52572 15.2139 1.56536C14.6551 1.72676 14.1667 2.07088 13.8269 2.5426L17.4747 6.17118ZM1.84941 18.1863L6.5875 16.5843L3.41274 13.4283L1.84941 18.1863Z"
        fill="#B9B9C3"
      />
      <path
        d="M17.2983 1.25297L17.2276 1.32372L17.2278 1.32391L17.2983 1.25297ZM18.6853 2.63071L18.6148 2.70167L18.6165 2.70328L18.6853 2.63071ZM18.6853 6.41949L18.6164 6.34689L18.6146 6.34875L18.6853 6.41949ZM11.4699 13.6286L11.3992 13.5578L11.3985 13.5586L11.4699 13.6286ZM8.02255 17.0729L7.95237 17.0017L7.95212 17.0019L8.02255 17.0729ZM7.61368 17.3293L7.64572 17.424L7.64689 17.4236L7.61368 17.3293ZM1.35235 19.4199L1.3206 19.3249L1.31566 19.3269L1.35235 19.4199ZM0.983563 19.5L0.977777 19.6004L0.98877 19.5999L0.983563 19.5ZM0.534607 18.8031L0.627971 18.8393L0.629561 18.8345L0.534607 18.8031ZM1.85742 14.7981L1.76275 14.7658L1.76247 14.7667L1.85742 14.7981ZM2.65913 12.395L2.75409 12.4264L2.75411 12.4263L2.65913 12.395ZM2.87559 12.0426L2.80478 11.972L2.80474 11.972L2.87559 12.0426ZM13.5784 1.30904L13.6492 1.37966L13.6505 1.37828L13.5784 1.30904ZM13.0813 3.3356L13.1522 3.26501L13.0816 3.19417L13.0107 3.26476L13.0813 3.3356ZM3.98996 12.395L3.91938 12.3242L3.84862 12.3947L3.91905 12.4655L3.98996 12.395ZM7.5736 15.9996L7.50268 16.0701L7.5733 16.1411L7.64421 16.0704L7.5736 15.9996ZM16.665 6.93214L16.7356 7.00294L16.8063 6.93236L16.7358 6.86155L16.665 6.93214ZM17.4747 6.17118L17.4042 6.24207L17.4748 6.31238L17.5454 6.24192L17.4747 6.17118ZM18.0359 5.61848L17.9631 5.54988L17.9622 5.55087L18.0359 5.61848ZM18.4589 4.55313H18.5589H18.4589ZM18.0359 3.48779L17.9625 3.55574L17.9631 3.55638L18.0359 3.48779ZM16.4966 1.94985L16.5656 1.87746L16.5651 1.87696L16.4966 1.94985ZM15.2139 1.56536L15.1967 1.46623L15.1861 1.46929L15.2139 1.56536ZM13.8269 2.5426L13.7458 2.48415L13.6959 2.55335L13.7564 2.61349L13.8269 2.5426ZM1.84941 18.1863L1.7544 18.1551L1.69197 18.3451L1.88144 18.2811L1.84941 18.1863ZM6.5875 16.5843L6.61953 16.6791L6.77258 16.6273L6.658 16.5134L6.5875 16.5843ZM3.41274 13.4283L3.48324 13.3574L3.36831 13.2432L3.31773 13.3971L3.41274 13.4283ZM15.4861 0.600018C16.1395 0.601979 16.7656 0.862157 17.2276 1.32372L17.369 1.18222C16.8696 0.683329 16.1929 0.402138 15.4867 0.400019L15.4861 0.600018ZM17.2278 1.32391L18.6148 2.70165L18.7557 2.55976L17.3688 1.18202L17.2278 1.32391ZM18.6165 2.70328C18.864 2.93792 19.0611 3.22046 19.1958 3.53367L19.3796 3.45465C19.2341 3.11648 19.0213 2.81145 18.7541 2.55813L18.6165 2.70328ZM19.1958 3.53367C19.3305 3.84687 19.4 4.1842 19.4 4.5251H19.6C19.6 4.15703 19.525 3.79281 19.3796 3.45465L19.1958 3.53367ZM19.4 4.5251C19.4 4.86599 19.3305 5.20332 19.1958 5.51653L19.3796 5.59555C19.525 5.25738 19.6 4.89317 19.6 4.5251H19.4ZM19.1958 5.51653C19.0611 5.82974 18.864 6.11227 18.6165 6.34691L18.7541 6.49207C19.0213 6.23875 19.2341 5.93372 19.3796 5.59555L19.1958 5.51653ZM18.6146 6.34875L11.3992 13.5578L11.5406 13.6993L18.7559 6.49023L18.6146 6.34875ZM11.3985 13.5586C10.2527 14.7274 9.10669 15.8644 7.95237 17.0017L8.09274 17.1442C9.24733 16.0066 10.3943 14.8687 11.5413 13.6986L11.3985 13.5586ZM7.95212 17.0019C7.84707 17.1062 7.72012 17.1858 7.58047 17.2349L7.64689 17.4236C7.8145 17.3646 7.96688 17.269 8.09298 17.1439L7.95212 17.0019ZM7.58165 17.2345C5.49735 17.9394 3.40574 18.628 1.32064 19.3251L1.38406 19.5147C3.46784 18.8181 5.56113 18.1289 7.64572 17.424L7.58165 17.2345ZM1.31566 19.3269C1.20793 19.3694 1.09402 19.3941 0.978355 19.4001L0.98877 19.5999C1.12602 19.5927 1.2612 19.5633 1.38904 19.5129L1.31566 19.3269ZM0.989313 19.4002C0.924299 19.3964 0.861096 19.3774 0.804859 19.3446L0.704123 19.5174C0.787578 19.566 0.881357 19.5943 0.977812 19.5998L0.989313 19.4002ZM0.804859 19.3446C0.748622 19.3118 0.700948 19.2662 0.665716 19.2115L0.497586 19.3198C0.549895 19.401 0.620666 19.4687 0.704123 19.5174L0.804859 19.3446ZM0.665716 19.2115C0.630486 19.1568 0.608695 19.0946 0.602116 19.0299L0.403142 19.0501C0.412914 19.1462 0.445277 19.2386 0.497586 19.3198L0.665716 19.2115ZM0.602116 19.0299C0.595536 18.9652 0.604354 18.8999 0.627851 18.8393L0.441362 18.767C0.406467 18.857 0.39337 18.9541 0.403142 19.0501L0.602116 19.0299ZM0.629561 18.8345L1.95238 14.8294L1.76247 14.7667L0.439652 18.7718L0.629561 18.8345ZM1.95209 14.8303C2.22484 14.0288 2.48955 13.2273 2.75409 12.4264L2.56418 12.3637C2.29959 13.1648 2.03517 13.9653 1.76275 14.7658L1.95209 14.8303ZM2.75411 12.4263C2.79294 12.3084 2.8588 12.2012 2.94645 12.1132L2.80474 11.972C2.69511 12.0821 2.61272 12.2162 2.56415 12.3638L2.75411 12.4263ZM2.9464 12.1132L13.6492 1.37965L13.5076 1.23843L2.80478 11.972L2.9464 12.1132ZM13.6505 1.37828C13.8877 1.13108 14.1728 0.93462 14.4883 0.800834L14.4102 0.616701C14.0698 0.76106 13.7622 0.973049 13.5062 1.2398L13.6505 1.37828ZM14.4883 0.800834C14.8038 0.667047 15.1433 0.598725 15.4861 0.600018L15.4868 0.400019C15.117 0.398624 14.7507 0.472343 14.4102 0.616701L14.4883 0.800834ZM13.0107 3.26476L3.91938 12.3242L4.06055 12.4659L13.1519 3.40643L13.0107 3.26476ZM3.91905 12.4655L7.50268 16.0701L7.64451 15.9291L4.06088 12.3245L3.91905 12.4655ZM7.64421 16.0704L16.7356 7.00294L16.5943 6.86133L7.50298 15.9288L7.64421 16.0704ZM16.7358 6.86155L13.1522 3.26501L13.0105 3.40618L16.5941 7.00272L16.7358 6.86155ZM17.5454 6.24192C17.7226 6.06479 17.9322 5.87942 18.1096 5.68608L17.9622 5.55087C17.7868 5.74203 17.5955 5.9091 17.404 6.10043L17.5454 6.24192ZM18.1086 5.68707C18.3978 5.38023 18.5589 4.97464 18.5589 4.55313H18.3589C18.3589 4.92362 18.2173 5.28015 17.9631 5.54989L18.1086 5.68707ZM18.5589 4.55313C18.5589 4.13163 18.3978 3.72604 18.1086 3.4192L17.9631 3.55638C18.2173 3.82612 18.3589 4.18265 18.3589 4.55313H18.5589ZM18.1092 3.41984C17.6099 2.88072 17.0869 2.37427 16.5656 1.87746L16.4276 2.02224C16.9485 2.51868 17.4677 3.0215 17.9625 3.55574L18.1092 3.41984ZM16.5651 1.87696C16.3844 1.7073 16.1668 1.58193 15.9293 1.51076L15.8719 1.70234C16.0797 1.76462 16.2701 1.87431 16.4281 2.02274L16.5651 1.87696ZM15.9293 1.51076C15.6918 1.43958 15.4411 1.42454 15.1968 1.46683L15.2309 1.6639C15.4447 1.6269 15.6641 1.64006 15.8719 1.70234L15.9293 1.51076ZM15.1861 1.46929C14.6058 1.6369 14.0986 1.99426 13.7458 2.48415L13.9081 2.60104C14.2347 2.1475 14.7043 1.81663 15.2416 1.66144L15.1861 1.46929ZM13.7564 2.61349L17.4042 6.24207L17.5452 6.10028L13.8974 2.4717L13.7564 2.61349ZM1.88144 18.2811L6.61953 16.6791L6.55547 16.4896L1.81738 18.0916L1.88144 18.2811ZM6.658 16.5134L3.48324 13.3574L3.34223 13.4993L6.517 16.6552L6.658 16.5134ZM3.31773 13.3971L1.7544 18.1551L1.94441 18.2176L3.50774 13.4596L3.31773 13.3971Z"
        fill="#B9B9C3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1744_575">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
